"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wsUrlFromCreds = void 0;
function wsUrlFromCreds({ wsBaseUrl, wsAuthToken }) {
    return `${wsBaseUrl}?wsAuthToken=${wsAuthToken}`;
}
exports.wsUrlFromCreds = wsUrlFromCreds;
//# sourceMappingURL=ws-connection.js.map